"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _versions = require("../../_utils/versions");

var _tokens = require("../../../tokens");

var _icon = _interopRequireDefault(require("../icon"));

var _fontIcon = _interopRequireWildcard(require("../font-icon"));

var _spinner = _interopRequireDefault(require("../spinner"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _context = require("../../context");

var _actionText = _interopRequireDefault(require("../_action-text"));

var _utilities = require("../../_utils/utilities");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n          ", " {\n            margin: 0 ", ";\n          }\n      "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n            ", ":last-child, svg:last-child {\n              margin-left: ", ";\n              float: right;\n              margin-top: 1px;\n            }\n          "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n            ", ":first-child, svg:first-child {\n              margin-right: ", ";\n              float: left;\n              margin-top: 1px;\n            }\n          "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n          ", ";\n          ", ";\n        "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        text-align: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  > span {\n    vertical-align: middle;\n  }\n  ", ";\n  display: inline-block;\n  ", ";\n  height: ", ";\n  box-sizing: border-box;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  border: 1px solid;\n  border-color: ", ";\n  border-radius: ", ";\n  background: ", ";\n  padding: 0 ", ";\n  cursor: ", ";\n  transition: border-color ", ",\n    background ", ";\n\n\n  ", ";\n\n  &:hover {\n    color: ", ";\n    background: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    background: ", ";\n    border-color: ", ";\n    outline: none;\n    span {\n      color: ", ";\n    }\n  }\n\n  &:active {\n    background: ", ";\n    border-color: ", ";\n    outline: none;\n    span {\n      color: ", ";\n    }\n    ", " path {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  &:hover, &:active, &:focus {\n    background: none;\n    outline: thin dotted;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    min-width: ", ";\n    max-width: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n      width: ", ";\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getViews = function getViews(props) {
  var color = (0, _versions.getColor)(props, 'button');
  var styles = {
    "default": {
      text: color["default"].text,
      icon: color["default"].icon,
      background: color["default"].background,
      border: color["default"].border,
      hoverBackground: color["default"].backgroundHover,
      hoverBorder: color["default"].borderHover,
      focusBackground: color["default"].backgroundFocus,
      focusBorder: color["default"].borderFocus,
      activeBackground: color["default"].backgroundActive,
      activeBorder: color["default"].borderActive
    },
    primary: {
      text: color.primary.text,
      icon: color.primary.icon,
      background: color.primary.background,
      border: color.primary.border,
      hoverBackground: color.primary.backgroundHover,
      hoverBorder: color.primary.borderHover,
      focusBackground: color.primary.backgroundFocus,
      focusBorder: color.primary.borderFocus,
      activeBackground: color.primary.backgroundActive,
      activeBorder: color.primary.borderActive
    },
    secondary: {
      text: color.secondary.text,
      textActive: color.secondary.textActive,
      icon: color.secondary.icon,
      background: color.secondary.background,
      border: color.secondary.border,
      hoverBackground: color.secondary.backgroundHover,
      hoverBorder: color.secondary.borderHover,
      focusBackground: color.secondary.backgroundFocus,
      focusBorder: color.secondary.borderFocus,
      activeBackground: color.secondary.backgroundActive,
      activeBorder: color.secondary.borderActive
    },
    link: {
      text: color.link.text,
      icon: color.link.icon,
      textActive: color.link.textActive,
      background: 'transparent',
      border: 'transparent',
      hoverText: color.link.hover,
      hoverBackground: 'transparent',
      hoverBorder: 'transparent',
      focusText: color.link.focus,
      focusBackground: 'transparent',
      focusBorder: 'transparent'
    },
    disabled: {
      icon: 'white',
      background: color.disabled.background,
      border: color.disabled.border
    }
  };

  if (props.view === 'secondary') {
    styles.disabled.background = color.disabled.secondary.background;
  } else if (props.view === 'link') {
    styles.disabled.background = color.disabled.link.background;
    styles.disabled.border = color.disabled.link.border;
  }

  return styles;
};

var getStyles = function getStyles(props) {
  var viewStyles = {};
  var properties = (0, _versions.getProperties)(props, 'button');

  if (props.disabled) {
    viewStyles = getViews(props)['disabled'];
  } else {
    viewStyles = getViews(props)[props.view] ? getViews(props)[props.view] : getViews(props)["default"];
  }

  var styles = _objectSpread({}, viewStyles);

  styles.height = properties.height;
  styles.radius = (0, _utilities.validCssUnit)(props.radius) ? props.radius : properties.radius;
  styles.minWidth = properties.minWidth;
  styles.maxWidth = properties.maxWidth;

  if (props.loading) {
    styles.background = styles.hoverBackground;
    styles.focusBackground = styles.hoverBackground;
    styles.activeBackground = styles.hoverBackground;
    styles.border = styles.hoverBorder;
    styles.focusBorder = styles.hoverBorder;
    styles.activeBorder = styles.hoverBorder;
  }

  if (props.text) {
    styles.padding = (0, _utilities.validCssUnit)(props.padding) ? props.padding : properties.padding;
  } else if ((props.icon || props.rightIcon) && !props.text) {
    styles.padding = 0;
    styles.minWidth = '32px';
  }

  if (props.view === 'link') {
    styles.background = 'transparent';
    styles.border = 'transparent';
  }

  styles.width = props.width;

  if (props.lean) {
    styles.width = 'initial';
    styles.padding = 0;
  }

  return styles;
};

var getWidths = function getWidths(props) {
  var _getStyles = getStyles(props),
      minWidth = _getStyles.minWidth,
      maxWidth = _getStyles.maxWidth,
      width = _getStyles.width;

  if ((0, _utilities.validCssUnit)(width)) {
    return (0, _styledComponents.css)(_templateObject(), width);
  }

  return (0, _styledComponents.css)(_templateObject2(), minWidth, maxWidth);
};

var getRandomNumber = function getRandomNumber() {
  return Math.random().toFixed(4) * 1000;
};

var getIcon = function getIcon(icon, size) {
  var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'currentColor';

  if (_utilities.iconPattern.test(icon)) {
    return _react["default"].createElement(_fontIcon["default"], {
      size: size,
      color: color,
      key: "".concat(icon, "-").concat(getRandomNumber())
    }, icon);
  }

  return _react["default"].createElement(_icon["default"], {
    key: "icon-".concat(icon, "-").concat(getRandomNumber()),
    size: size,
    name: icon,
    color: color
  });
};

var ButtonContent = function ButtonContent(props) {
  if (props.view === 'plain') {
    return _react["default"].createElement(Button.Plain, props, props.text);
  }

  var content;
  var view = props.view;

  if (props.view === 'link') {
    view = 'tertiary';
  }

  if (props.disabled && props.view === 'link') {
    view = 'disabled';
  } else if (props.disabled) {
    view = 'disabled';
  }

  var data = [];

  if (props.icon) {
    var iconSize = props.iconSize,
        iconColor = props.iconColor,
        icon = props.icon;
    data.push(getIcon(icon, iconSize, iconColor));
  }

  if (props.text) {
    data.push(props.text);
  }

  if (props.rightIcon) {
    var rightIcon = props.rightIcon,
        _iconSize = props.iconSize,
        _iconColor = props.iconColor;
    data.push(getIcon(rightIcon, _iconSize, _iconColor));
  }

  content = _react["default"].createElement(_actionText["default"], {
    key: "text",
    type: view,
    view: props.view
  }, data);
  var Element = props.href ? Button.LinkElement : Button.Element;
  return _react["default"].createElement(Element, props, props.override || content);
};

var Button = function Button(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var override; // override the content of button in case of loading state.

  if (props.loading) override = _react["default"].createElement(_spinner["default"], {
    inverse: props.primary
  });

  var button = _react["default"].createElement(ButtonContent, _extends({}, props, {
    text: children,
    override: override
  })); // If a label was specified, wrap the Button in a Tooltip.


  if (props.label) {
    return _react["default"].createElement(_tooltip["default"], {
      content: props.label
    }, button);
  }

  return button;
};

Button.Plain = _styledComponents["default"].button(_templateObject3());
Button.Element = _styledComponents["default"].button(_templateObject4(), _tokens.fonts.family.text, function (props) {
  if (props.alignText === 'left' || props.alignText === 'right') {
    return (0, _styledComponents.css)(_templateObject5(), props.alignText);
  }

  return null;
}, function (props) {
  return getWidths(props);
}, function (props) {
  return getStyles(props).height;
}, function (props) {
  if (props.borderOnHoverOnly) {
    return 'transparent';
  }

  return getStyles(props).border;
}, function (props) {
  return getStyles(props).radius;
}, function (props) {
  return getStyles(props).background;
}, function (props) {
  return getStyles(props).padding;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, _tokens.misc.animationDuration, _tokens.misc.animationDuration, function (props) {
  return props.text ? (0, _styledComponents.css)(_templateObject6(), function (props) {
    return props.icon && (0, _styledComponents.css)(_templateObject7(), _fontIcon.StyledIcon, _tokens.spacing.xsmall);
  }, function (props) {
    return props.rightIcon && (0, _styledComponents.css)(_templateObject8(), _fontIcon.StyledIcon, _tokens.spacing.xsmall);
  }) : (0, _styledComponents.css)(_templateObject9(), _fontIcon.StyledIcon, _tokens.spacing.xxsmall);
}, function (props) {
  return getStyles(props).hoverText || getStyles(props).text;
}, function (props) {
  return getStyles(props).hoverBackground;
}, function (props) {
  return getStyles(props).hoverBorder;
}, function (props) {
  return getStyles(props).focusBackground;
}, function (props) {
  return getStyles(props).focusBorder;
}, function (props) {
  return getStyles(props).textActive;
}, function (props) {
  return getStyles(props).activeBackground;
}, function (props) {
  return getStyles(props).activeBorder;
}, function (props) {
  return getStyles(props).textActive;
}, _icon["default"].Element, function (props) {
  return getStyles(props).textActive;
});
Button.LinkElement = Button.Element.withComponent('a');
Button.propTypes = {
  /** The visual style used to convey the button's purpose */
  view: _propTypes["default"].oneOf(['default', 'primary', 'secondary', 'link', 'plain']),
  alignText: _propTypes["default"].oneOf(['left', 'right']),

  /** Disables the button, changing the visual style and make it unable to be pressed */
  disabled: _propTypes["default"].bool,

  /** Loading state when waiting for an action to complete */
  loading: _propTypes["default"].bool,
  borderOnHoverOnly: _propTypes["default"].bool,

  /** Error state */
  error: _propTypes["default"].bool,

  /** Name of icon */
  icon: _propTypes["default"].string,

  /** Name of right icon */
  rightIcon: _propTypes["default"].string,

  /** Tooltip to show when the user hovers over the button */
  label: _propTypes["default"].string,

  /** The URL to navigate to when the button is clicked */
  href: _propTypes["default"].string,

  /** onClick handler */
  onClick: _propTypes["default"].func,
  iconSize: _propTypes["default"].number,
  iconColor: _propTypes["default"].string,

  /** left right padding */
  padding: _propTypes["default"].string,

  /** removes padding and width */
  lean: _propTypes["default"].bool
};
Button.defaultProps = {
  view: 'default',
  type: 'button',
  disabled: false,
  loading: false,
  error: false,
  borderOnHoverOnly: false,
  iconSize: 16,
  lean: false
};
Button.displayName = 'Button';
Button.Element.displayName = 'ButtonElement';
var StyledButton = Button.Element;
exports.StyledButton = StyledButton;

var _default = (0, _context.withVersion)(Button);

exports["default"] = _default;